import { InfiniteScrollModule } from 'angular2-infinite-scroll';
import { CommonPipesModule } from './pipes/common-pipes.module';
import { UploadLogoComponent } from './components/uploadlogo/upload-logo.component';
import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { MaterialModule } from '@angular/material';
import { ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import {
    CalendarModule,
    DataScrollerModule,
    DropdownModule,
    AutoCompleteModule,
    ConfirmDialogModule,
    OverlayPanelModule
} from 'primeng/primeng';
import { DatepickerModule } from 'angular2-material-datepicker';
import { Angular2FontAwesomeModule } from 'angular2-font-awesome/angular2-font-awesome';
import { ImageCropperModule } from 'ng2-img-cropper';
import { MultiSelectModule, EditorModule } from 'primeng/primeng';

import { CreatePersonComponent } from './components/createperson/create-person.component';
import { CreateOrganisationComponent } from './components/createorganisation/create-organisation.component';
import { GenericSearchComponent } from './components/genericsearch/generic-search.component';
import { InstantScreeningDialogComponent } from './components/instant-screening-dialog/instant-screening-dialog.component';
import { GoogleSearchResultsComponent } from './components/googlesearchresults/google-search-results.component';
import { LegalStructureComponent } from './components/legalstructure/legal-structure.component';
import { ModalBoxComponent } from './components/modalbox/modal-box.component';
import { ConfirmationDialogComponent } from './components/confirmationdialog/confirmation-dialog.component';
import { TrackingService } from './services/tracking/google-analytics-events.service';
import { CurrencyService } from './services/currency-service';
import { AddDocumentComponent } from 'app/shared/components/adddocument/add-document.component';
import { ActivityComponent } from 'app/shared/components/activity/activity.component';
import { AddActivityComponent } from 'app/shared/components/activity/addactivity/add-activity.component';
import { EditActivityDetailsComponent } from 'app/shared/components/activity/editactivitydetails/edit-activity-details.component';
import { EditActivitySummaryComponent } from 'app/shared/components/activity/editactivitysummary/edit-activity-summary.component';
import { ActivityService } from 'app/shared/components/activity/activity.service';
import { MonitoringStatusService } from 'app/shared/services/monitoring-status.service';
import { RelationDropDownComponent } from './components/relation-drop-down/relation-drop-down.component';
import {TransactionProfilePipe} from '../entities/transaction-profile/transaction-rule/transaction-profile-description.pipe';

@NgModule({
    declarations: [
        CreatePersonComponent,
        CreateOrganisationComponent,
        GenericSearchComponent,
        InstantScreeningDialogComponent,
        LegalStructureComponent,
        GoogleSearchResultsComponent,
        ModalBoxComponent,
        ConfirmationDialogComponent,
        UploadLogoComponent,
        AddDocumentComponent,
        AddActivityComponent,
        EditActivityDetailsComponent,
        EditActivitySummaryComponent,
        ActivityComponent,
        RelationDropDownComponent,
        TransactionProfilePipe
    ],
    imports: [
        MaterialModule.forRoot(),
        ReactiveFormsModule,
        FlexLayoutModule.forRoot(),
        BrowserModule,
        CalendarModule,
        DataScrollerModule,
        DropdownModule,
        FormsModule,
        AutoCompleteModule,
        ConfirmDialogModule,
        DatepickerModule,
        Angular2FontAwesomeModule,
        ImageCropperModule,
        MultiSelectModule,
        EditorModule,
        CommonPipesModule,
        InfiniteScrollModule,
        OverlayPanelModule
    ],
    providers: [
        CurrencyService,
        TrackingService,
        ActivityService,
        MonitoringStatusService
    ],
    entryComponents: [
        CreateOrganisationComponent,
        CreatePersonComponent,
        ModalBoxComponent,
        ConfirmationDialogComponent,
        UploadLogoComponent,
        AddDocumentComponent,
        AddActivityComponent,
        EditActivityDetailsComponent,
        EditActivitySummaryComponent,
        InstantScreeningDialogComponent
    ],
    exports: [
        GenericSearchComponent,
        LegalStructureComponent,
        ActivityComponent,
        RelationDropDownComponent,
        TransactionProfilePipe
    ]
})

export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts